import * as React from 'react';
import styled from 'styled-components';
import { Product } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import { Text } from '@packages/ui';
import { formattedPrice } from './utils';

const PriceTextSale = styled(Text)`
  text-decoration: line-through;
`;

const Wrapper = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  span {
    display: inline-block;
  }
`;

export interface DefaultPriceProps extends Pick<Product, 'price' | 'features'> {
  className?: string;
}

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

export const DefaultProductPrice: React.FC<DefaultPriceProps> = ({ price, features, className }) => {
  if (!price) {
    return null;
  }

  const sale = (features && features.sale) || false;

  const { value, valueFormer } = price;
  const withSale = sale && valueFormer && valueFormer > value;
  return (
    <Wrapper className={className}>
      <Text
        tag="span"
        fontWeight="bold"
        fontSize={[7, 7, 8]}
        color={sale ? 'primary' : 'kilamanjaro'}
        data-testid="default-product-price:price"
      >
        {formattedPrice(value, APP_TLD)}
      </Text>
      {withSale && valueFormer && (
        <PriceTextSale
          tag="span"
          fontWeight="normal"
          fontSize={[2, 4]}
          color="kilamanjaro"
          marginLeft={[2]}
          data-testid="default-product-price:sale-price"
        >
          {formattedPrice(valueFormer, APP_TLD)}
        </PriceTextSale>
      )}
    </Wrapper>
  );
};
